import {Component, OnDestroy, OnInit} from '@angular/core';

import {RegistryService} from "../../../../../services/registry.service";
import {AuthService} from "../../../../../../../services/auth.service";
import {PaymentService} from "../../../../../services/payment.service";
import {ActivatedRoute} from "@angular/router";

declare var Checkout;

@Component({
    selector: 'app-mastercard-payment-cancel',
    templateUrl: './mastercard-payment-cancel.component.html',
    styleUrls: ['./mastercard-payment-cancel.component.css']
})
export class MastercardPaymentCancelComponent implements OnInit, OnDestroy {

    userLoggedOutEvent;

    resultIndicator;
    sessionVersion;

    paymentResult = null;

    constructor(public registry: RegistryService,
                private authService: AuthService,
                private paymentService: PaymentService,
                private route: ActivatedRoute
    ) {

    }

    ngOnInit(): void {



    }

    ngOnDestroy(): void {
    }

}
